import { useState, useEffect } from "react";
import moment from "moment"; // Import moment.js
import styles from "./Timer.module.css";

interface TimerProps {
  expiryTimestamp: string; // UTC format timestamp from API
  onExpire?: () => void;
}

const Timer: React.FC<TimerProps> = ({ expiryTimestamp, onExpire }) => {
  const calculateTimeLeft = () => {
    const expiryTime = moment.utc(expiryTimestamp).valueOf();
    const currentTime = moment(new Date()).valueOf();
    const remainingTime = Math.floor((expiryTime - currentTime) / 1000);

    return remainingTime > 0 ? remainingTime : null;
  };

  const [timeLeft, setTimeLeft] = useState<number | null>(calculateTimeLeft());

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());

    const interval = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (newTimeLeft === null) {
        clearInterval(interval);
        onExpire && onExpire();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiryTimestamp]);

  if (timeLeft === null) return null;

  const formatTime = (t: number) => {
    const mins = Math.floor(t / 60);
    const secs = t % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <div className={`${styles.timer} ${timeLeft === null ? styles.expired : ""}`}>
      {formatTime(timeLeft)}
    </div>
  );
};

export default Timer;
